import WidenAssetSource from "./WidenAssetSource";
import WidenIcon from "./WidenIcon";

export default {
  title: "Widen",
  name: "asset-source-widen-image",
  icon: WidenIcon,
  component: WidenAssetSource
};
